const backendUrl = process.env.REACT_APP_BACKEND_URL || ''

/**
 * Resolves a stored media src to a loadable URL.
 *
 * Backend-processed videos are stored as server-relative paths (e.g. "/media/videos/video-..mp4")
 * and must be prefixed with the backend origin to load from the React dev/app origin. Absolute
 * URLs (legacy GCS links, blob:/data: previews) are returned unchanged.
 *
 * @param {string} src
 * @returns {string}
 */
export function resolveMediaUrl(src) {
    if (!src) {
        return src
    }
    if (/^(https?:|blob:|data:)/i.test(src)) {
        return src
    }
    return `${backendUrl}${src.startsWith('/') ? '' : '/'}${src}`
}
